/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import ShortenerHeader from 'app/components/Headers/ShortenerHeader.jsx';
import ShortenerListItem from 'app/components/ShortenerLists/ShortenerListItem.jsx';
import NewShortenerItem from 'app/components/ShortenerLists/NewShortenerItem.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import ShortenerProvider from 'app/redux/Providers/ShortenerProvider.jsx';
import DomainProvider from 'app/redux/Providers/DomainProvider.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import isDefaultShortener from 'app/modules/isDefaultShortener.js';

class ShortenersView extends React.Component {
	constructor(props) {
		super(props);

		let id = this.props.router.params.shortenerId ? this.props.router.params.shortenerId : null,
			type = this.props.router.params.type ? this.props.router.params.type : '';

		this.state = {
			options: [],
			filteredOptions: [],
			filterOptions: {},
			detailId: id,
			detailType: type,
			detail: {},
			newShortenerType: 0,
			newCredId: '',
			updateCredId: '',
			errors: {},
			notifications: {},
			showFilter: false,
			currentPath: this.props.router.location.pathname,
			currentModal: null,
			filterLabel: 'All Shorteners',
			isReauthorizing: false
		};

		this.onShowFilter = this.onShowFilter.bind(this);
		this.onFilter = this.onFilter.bind(this);
		this.onAddShortener = this.onAddShortener.bind(this);
		this.onNewTypeChange = this.onNewTypeChange.bind(this);
		this.loadDetail = this.loadDetail.bind(this);
		this.addOptions = this.addOptions.bind(this);
		this.itemHandler = this.itemHandler.bind(this);
		this.dropdownResetHandler = this.dropdownResetHandler.bind(this);
		this.detailHandler = this.detailHandler.bind(this);
		this.setAsDefault = this.setAsDefault.bind(this);
		this.applyToAll = this.applyToAll.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.reauthService = this.reauthService.bind(this);

	}

	componentDidMount() {
		let query = this.props.router.query,
			state = '',
			stateParts = '',
			params = {};

		this.props.getShorteners();
		this.props.getDomains();
		// the list leaves out what the settings show, so one opened from its own address is loaded too
		this.loadDetail();

		if (query !== null && query.state && query.state.match('REAUTH')) {
			let state = query.state;
			if (state.match(/REAUTH/)) {
				let stateParts = state.split("_");
				params = {
					type: 'shortener',
					shortenerId: stateParts[2]
				};
				this.setState({
					detailId: params.shortenerId,
					detailType: params.type
				});
			} else {
				params = this.props.router.params;
			}
			this.props.authReturnHandler({
				path: '/config/shorteners/detail/' + params.type + '/' + params.shortenerId
			}, (credId) => {
				this.props.addMessage(UserMessages.generateMessage(UserMessages.shortener.reauthorized, 'SHORTENER_UPDATE'));
				this.setState({
					updateCredId: credId
				});
				this.props.resetAuthState();
			});
		} else {
			this.props.authReturnHandler({
				path: '/config/shorteners/new',
			}, (type, credId) => {
				this.setState({
					newShortenerType: type,
					newCredId: credId
				});
				this.props.resetAuthState();
			});
		}

	}

	// Synthetic rows for saID = 0 (No Shortener) and saID = 1 (dlvr.it placeholder).
	getPlaceholderShorteners() {
		let saId = this.props.user.detail.defaultSaId,
			pdId = this.props.user.detail.defaultPdId;
		return [
			{
				id: 0,
				default: isDefaultShortener({id: 0}, saId, pdId) ? 1 : 0,
				name: 'No Shortener',
				errCount: 0,
				applyRoutes: 0,
				applyOutputs: 0
			},
			{
				id: 1,
				ssID: 1,
				default: isDefaultShortener({id: 1, ssID: 1}, saId, pdId) ? 1 : 0,
				name: 'dlvr.it',
				errCount: 0,
				applyRoutes: 0,
				applyOutputs: 0
			}
		];
	}

	componentDidUpdate(prevProps, prevState) {
		let currentPath = this.state.currentPath,
			errorList = [],
			errors = this.state.errors,
			detailId = this.state.detailId,
			detailType = this.state.detailType,
			details = this.state.details,
			update = false,
			detail = {},
			newId = 0,
			testErrors = null;

		if ((this.state.detailId !== undefined &&
			this.state.detailId != prevState.detailId) &&
			this.state.detailType !== '') {
			this.loadDetail();
			return;
		}

		if (this.props.router.location.pathname !== currentPath) {
			currentPath = this.props.router.location.pathname;
			errors = {};
			if (currentPath.match(/\/new$/)) {
				detailId = null;
				detailType = '';
				details ={};
				errors = {};
				update = true;
			}
		}

		// catch a cancel on detail which just pushes /config/shorteners into the location and
		// doesn't reset any state
		if (!prevProps.router.location.pathname.match(/shorteners$/) && this.props.router.location.pathname.match(/shorteners$/)) {
			if (this.state.detailId !== null) {
				detailId = null;
				detailType = '';
				details ={};
				errors = {};
				update = true;
			}
		}

		if (update) {
			this.setState({
				currentPath: currentPath,
				detailId: detailId,
				detailType: detailType,
				details: details,
				errors: errors
			});
		}

		if (prevProps.shorteners.length > this.props.shorteners.length ||
			prevProps.domains.length > this.props.domains.length) {
			this.props.router.navigate('/config/shorteners');
			this.addOptions();
		} else if (prevProps.shorteners.length < this.props.shorteners.length && (prevProps.app.loading.SHORTENER_LIST === false && this.props.app.loading.SHORTENER_LIST === false)) {
			let newShortener = null;
			for (let i = 0; i < this.props.shorteners.length; ++i) {
				if(_.findWhere(prevProps.shorteners, {id: parseInt(this.props.shorteners[i].id)}) === undefined) {
					newShortener = this.props.shorteners[i];
					break;
				}
			}
			if (newShortener) {
				this.props.router.navigate('/config/shorteners/detail/shortener/' + newShortener.id);
				this.setState({
					detailId: newShortener.id,
					detailType: 'shortener'
				});
			}
			this.addOptions();
		} else if (prevProps.domains.length < this.props.domains.length && (prevProps.app.loading.DOMAIN_LIST === false && this.props.app.loading.DOMAIN_LIST === false)) {
			this.addOptions();
		}

		if (this.state.detailId !== null && this.state.detailType == 'shortener') {
			let id = parseInt(this.state.detailId, 10);
			if (id === 0 || id === 1) {
				detail = this.getPlaceholderShorteners()[id];
			} else {
				detail = this.props.findShortener(this.state.detailId);
			}
			if (!_.isEmpty(detail) && !_.isEqual(this.state.detail, detail)) {
				this.setState({
					detail
				});
			}
		}

		if (prevProps.domains.length < this.props.domains.length && (prevProps.app.loading.DOMAIN_LIST === false && this.props.app.loading.DOMAIN_LIST === false)) {
			let newDomain = this.props.domains.find((item) => !prevProps.domains.some((other) => parseInt(other.id, 10) === parseInt(item.id, 10)));
			if (newDomain) {
				this.props.router.navigate('/config/shorteners/detail/domain/' + newDomain.id);
				this.setState({
					detailId: newDomain.id,
					detailType: 'domain'
				});
			}
		}

		if (this.state.detailId !== null && this.state.detailType == 'domain' && _.isEmpty(this.state.detail)) {
			detail = this.props.findDomain(this.state.detailId);
			if (!_.isEmpty(detail)) {
				this.setState({
					detail: detail
				});
			}
		}

		errorList = this.props.getApiErrors([
			'DOMAIN_CREATE',
			'DOMAIN_UPDATE',
			'DOMAIN_DELETE',
			'SHORTENER_CREATE',
			'SHORTENER_UPDATE',
			'SHORTENER_DELETE',
			'SHORTENER_TEST'
		]);

		if (errorList.length && _.isEmpty(this.state.errors)) {
			this.setState({
				errors: errorList[0]
			});
		} else if (!_.isEmpty(this.state.errors) && errorList.length === 0) {
			this.setState({
				errors: {}
			});
		}

		// the rows are copies, so a saved shortener or domain shows in the list only once they're made again
		if (prevProps.shorteners !== this.props.shorteners || prevProps.domains !== this.props.domains) {
			this.addOptions();
		}

		if (prevProps.app.loading.SHORTENER_LIST === true && this.props.app.loading.SHORTENER_LIST === false) {
			this.addOptions();
		}

		if (prevProps.app.loading.DOMAIN_LIST === true && this.props.app.loading.DOMAIN_LIST === false) {
			this.addOptions();
		}

		if (prevProps.app.loading.SHORTENER_UPDATE === true && this.props.app.loading.SHORTENER_UPDATE === false) {
			if (errorList.length === 0) {
				this.setState({
					updateCredId: ''
				});
			}
		}

	}

	onShowFilter(e) {
		e.preventDefault();
		e.stopPropagation();

		let filter = (this.state.showFilter) ? false : true;

		this.setState({
			showFilter: filter
		});

	}

	onFilter(item) {
		let filteredOptions = [],
			filterLabel = 'All Shorteners';

		if (item.id !== '') {
			for (let i = 0; i < this.state.options.length; ++i) {
				if (this.state.options[i].ssID) {
					if (item.type == this.state.options[i].ssID) {
						filteredOptions.push(this.state.options[i]);
					}
				} else if (item.type == "1000" && this.state.options[i].domain) {
					filteredOptions.push(this.state.options[i]);
				}
			}
			filterLabel = filteredOptions.length + " " + item.name;
		}

		this.setState({
			filteredOptions: filteredOptions,
			showFilter: false,
			filterLabel: filterLabel
		});

	}

	onAddShortener() {

		this.props.router.navigate('/config/shorteners/new');

	}

	onNewTypeChange() {

		this.props.deleteApiError([
			'DOMAIN_CREATE',
			'DOMAIN_UPDATE',
			'DOMAIN_DELETE',
			'SHORTENER_CREATE',
			'SHORTENER_UPDATE',
			'SHORTENER_DELETE',
			'SHORTENER_TEST'
		]);
		// clear out any creds in state
		this.setState({
			newCredId: '',
			newShortenerType: 0
		});

	}

	loadDetail() {
		// 0 and 1 are reserved for shorteners and domain defaults (dlvr.it / no shortening)
		// if present, just send the default object to the detail
		// component and don't try to load up a non-existant entity
		if (this.state.detailId !== null && parseInt(this.state.detailId, 10) > 1) {
			if (this.state.detailType == 'shortener') {
				this.props.getShortener(this.state.detailId);
			} else if (this.state.detailType == 'domain') {
				this.props.getDomain(this.state.detailId);
			}
		}

	}

	addOptions(options) {
		let newFilterOptions = {},
			params = {},
			option = null,
			allOptions = [],
			realOptions = [];

		// Pin synthetic rows above the alphabetized real shorteners + domains.
		realOptions = realOptions.concat(this.props.shorteners);
		realOptions = realOptions.concat(this.props.domains);
		realOptions = _.sortBy(realOptions, function(option){
			if (option.domain) {
				return option.domain.toLowerCase();
			} else {
				return option.name.toLowerCase();
			}
		});

		allOptions = [...this.getPlaceholderShorteners(), ...realOptions];

		for (let i = 0; i < allOptions.length; ++i) {
			option = allOptions[i];
			if (parseInt(option.id, 10) > 1) {
				if (option.ssID) {
					if (!newFilterOptions[option.ssID]) {
						newFilterOptions[option.ssID] = 0;
					}
					++newFilterOptions[option.ssID];
				} else {
					if (!newFilterOptions["1000"]) {
						newFilterOptions["1000"] = 0;
					}
					++newFilterOptions["1000"];
				}
			}
		}

		this.setState({
			options: allOptions,
			filterOptions: newFilterOptions
		});
	}

	itemHandler(item) {
		let type = '';

		if (!item) {
			return null;
		}

		// The No Shortener synthetic (id=0, no ssID) is a shortener-service choice,
		// not a domain — must match the derivation in ShortenerListItem.
		type = (item.ssID || parseInt(item.id, 10) === 0) ? 'shortener' : 'domain';

		return (
			<ShortenerListItem
				{...this.props}
				key={item.id + "-" + type}
				item={item}
				itemType={type}
				itemDetail={this.state.detail}
				detailId={this.state.detailId}
				detailHandler={this.detailHandler}
				setAsDefault={this.setAsDefault}
				applyToAll={this.applyToAll}
				deleteItem={this.deleteItem}
				updatedCreds={this.state.updateCredId}
				errors={this.state.errors}
				reauthHandler={this.reauthService}
				defaultPdId={this.props.user.detail.defaultPdId}
				defaultSaId={this.props.user.detail.defaultSaId} />
		);
	}

	dropdownResetHandler(which) {

		this.setState({
			showFilter: false
		});

	}

	detailHandler(e) {
		let id = e.currentTarget.dataset.id,
			type = e.currentTarget.dataset.type,
			detail = {},
			errors = this.state.errors;

		if (!id || (id && id == this.state.detailId)) {
			this.props.router.navigate('/config/shorteners');
			id = null;
			type = '';
			this.props.deleteApiError(['SHORTENER_TEST']);
			this.props.deleteMessage(['SHORTENER_UPDATE', 'SHORTENER_TEST', 'DOMAIN_UPDATE']);
			errors = null;
		} else {
			this.props.router.navigate('/config/shorteners/detail/' + type + '/' + id);
		}

		// clear out any messages
		if (type === 'shortener') {
			this.props.deleteApiError(['SHORTENER_CREATE', 'SHORTENER_UPDATE', 'SHORTENER_DELETE']);
		} else if (type == 'domain') {
			this.props.deleteApiError(['DOMAIN_CREATE', 'DOMAIN_UPDATE', 'DOMAIN_DELETE']);
		}

		let synthId = parseInt(id, 10);
		if (synthId === 0 || synthId === 1) {
			detail = this.getPlaceholderShorteners()[synthId];
		}

		this.setState({
			detailId: id,
			detailType: type,
			detail: detail,
			errors: errors
		});

	}

	setAsDefault(type, id) {

		if (type === 'shortener') {
			this.props.setDefaultShortener(id);
		} else if (type === 'domain') {
			this.props.setDefaultDomain(id);
		}

	}

	applyToAll(type, id, applyToType) {

		if (type === 'shortener') {
			this.props.applyShortener(id, applyToType);
		} else if (type === 'domain') {
			this.props.applyDomain(id, applyToType);
		}

	}

	deleteItem(type, id) {

		let onDelete = (e) => {
				e.preventDefault();
				if (type === 'shortener') {
					this.props.deleteShortener(id);
				} else if (type === 'domain') {
					this.props.deleteDomain(id);
				}
				this.props.closeAllModals();
			},
			onCancel = () => {
				this.props.closeAllModals();
			},
			modal = (
				<DeleteModal
					confirmAction={onDelete}
					cancelAction={onCancel}
					modalCopy={`Are you sure you want to remove this ${type}?`} />
			);

		this.props.addModal(modal);

	}

	reauthService(e) {
		let serviceId = e.currentTarget.dataset.serviceid,
			accountId = e.currentTarget.dataset.id,
			url = "/remote/beginreauth?ssID=:ssId&saID=:saId&state=:state&final=:final",
			date = new Date(),
			state = ['REAUTHSHORT', serviceId, accountId, date.getTime()].join("_"),
			constants = this.props.app.config.constants;

		e.preventDefault();
		e.stopPropagation();

		if (this.state.isReauthorizing) {
			return;
		}

		this.setState({
			isReauthorizing: true
		}, () => {
			url = url.replace(':ssId', serviceId);
			url = url.replace(':saId', accountId);
			url = url.replace(':state', state);
			let finalUrl = this.props.cleanUrl(window.location.href);
        	url = url.replace(':final', window.encodeURIComponent(finalUrl));
			window.location.assign(url);
		});

	}

	render() {
		let header = null,
			main = null,
			newShortener = null,
			options = (this.state.filteredOptions.length) ? this.state.filteredOptions : this.state.options;

		header = (
			<ShortenerHeader
				{...this.props}
				shorteners={this.state.filterOptions}
				onShowFilter={this.onShowFilter}
				onFilter={this.onFilter}
				onAddShortener={this.onAddShortener}
				showFilter={this.state.showFilter}
				resetHandler={this.dropdownResetHandler}
				filterLabel={this.state.filterLabel} />
		);

		if (this.props.router.location.pathname.match("shorteners/new")) {
			newShortener = (
				<NewShortenerItem
					{...this.props}
					key="new"
					creds={this.state.newCredId}
					shortenerType={this.state.newShortenerType}
					errors={this.state.errors}
					onNewTypeChange={this.onNewTypeChange} />
			);
		}

		main = (
			<ul className="dlvr-list-component">
				{newShortener}
				{options.map(this.itemHandler, this)}
			</ul>
		);

		return (
			<Content header={header} main={main} modal={this.state.currentModal}/>
		);
	}
};

ShortenersView.displayName = "ShortenersView";

const enhance = compose(
	ComponentWithContext,
	ShortenerProvider,
	DomainProvider
);

export default enhance(ShortenersView);
